<template>
	<div class="ps-2 pe-2 d-flex align-items-center">
		<ProgressSpinner class="ps-2 pe-2 align-items-center" style="width: 30px; height: 30px;" strokeWidth="5"></ProgressSpinner>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	
	export default defineComponent({
	});
</script>